import axios from 'axios'
const request = axios.create({
  baseURL: '/api/api'  // 👈 只留这个，借助代理访问后端
  // baseURL: '/api'  // 👈 只留这个，借助代理访问后端
})
export default request